// Mutfak Siparişleri (hızlı satış / restoran) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.kitchenOrders';

export const salesKitchenOrdersGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Mutfak siparişleri nasıl takip edilir?'),
  intro: t(`${G}.intro`, 'Mutfağa gönderilen bugünkü siparişleri izler, durumlarını ilerletir ve fişlerini yeniden yazdırırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve yenile'),
    body: t(`${G}.regions.body`, 'Sipariş tablosu'),
    footer: t(`${G}.regions.footer`, 'Fiş Yazdır / durum düğmesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi siparişler listelenir?'),
      text: t(`${G}.s1.text`, 'Yalnız bugün bu moddan (Hızlı Satış veya Restoran) mutfağa gönderilen ve henüz teslim edilmemiş siparişler görünür; iptal edilen ve teslim edilenler listede yoktur. Başlıktaki sayı sipariş adedidir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Liste 30 saniyede bir kendiliğinden yenilenir; yenile simgesiyle hemen yenileyebilirsiniz.'),
        t(`${G}.s1.tip2`, 'Ekran bir şubeye bağlıysa yalnız o şubenin siparişleri görünür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tabloyu okuyun'),
      text: t(`${G}.s2.text`, 'Her satırda Sipariş No (ör. HS-19), sipariş saati, Bekleme süresi, Tutar ve Durum görünür. Bekleme 15 dakikayı geçince turuncu, 30 dakikayı geçince kırmızı olur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Siparişi seçin'),
      text: t(`${G}.s3.text`, 'İşlem yapmak istediğiniz siparişin satırına dokunun. Seçili sipariş altta "Seçili: …" olarak yazar.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Durumu ilerletin'),
      text: t(`${G}.s4.text`, 'Sağ alttaki düğme siparişin durumuna göre değişir: Beklemede veya Hazırlanıyor iken "HAZIR", Hazır iken "TESLİM EDİLDİ". Teslim edilen sipariş bir sonraki yenilemede listeden kalkar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Bu ekran yalnız sipariş durumunu değiştirir; ödeme almaz, stok veya kasa hareketi yapmaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Fişi yeniden yazdırın'),
      text: t(`${G}.s5.text`, '"Fiş Yazdır" seçili siparişin fişini tekrar basar. Ekran ayarlarında "Yazarkasa ile Birlikte Fiş Yazıcısı Kullan" kapalıysa fiş basılmaz ve uyarı çıkar. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
